import { render, staticRenderFns } from "./trusIncomeDaily.vue?vue&type=template&id=1a83f70d&scoped=true&"
import script from "./trusIncomeDaily.vue?vue&type=script&lang=js&"
export * from "./trusIncomeDaily.vue?vue&type=script&lang=js&"
import style0 from "./trusIncomeDaily.vue?vue&type=style&index=0&id=1a83f70d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83f70d",
  null
  
)

export default component.exports